import React from "react";

interface OctagonProps {
  a?: string | number;
  foldType?: string;
  foldDirection?: number;
  arrowColor?: string;
  textColor?: string;
}

const Octagon: React.FC<OctagonProps> = ({
  a = "",
  foldType = "",
  foldDirection = 1,
  arrowColor = "#1E8F31",
  textColor = "#000"
}) => {
  return (
    <svg
      width="216"
      height="210"
      viewBox="-30 0 212 196"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Octagon */}
      <path
        d="M38.7013 70.9478L76.9478 32.7013L131.037 32.7013L169.283 70.9478L169.283 125.037L131.037 163.283L76.9478 163.283L38.7013 125.037L38.7013 70.9478Z"
        stroke="#1E8F31"
        strokeWidth="3"
      />

      {/* Arrows */}
      <path
        d="M21 28L17.5359 34L24.4641 34L21 28ZM21 167L24.4641 161L17.5359 161L21 167ZM20.4 33.4L20.4 161.6L21.6 161.6L21.6 33.4L20.4 33.4Z"
        fill={arrowColor}
      />

      {/* Letters */}
      <text
        xmlSpace="preserve"
        textAnchor="end"
        fontFamily="Roboto"
        fontSize="12"
        y="100.54404"
        x="17.36436"
        fill={textColor}
      >
        A: {a}
      </text>

      {/* Bi Fold V */}
      {foldType === "Bi-Fold" && foldDirection === 2 && (
        <line
          x1="103.6"
          y1="37"
          x2="103.6"
          y2="160"
          stroke="#1E8F31"
          strokeWidth="1.2"
          strokeDasharray="6 6"
        />
      )}

      {/* Tri Fold V */}
      {foldType === "Tri-Fold" && foldDirection === 2 && (
        <>
          <line
            x1="79.6"
            y1="37"
            x2="79.6"
            y2="160"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="128.6"
            y1="37"
            x2="128.6"
            y2="160"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Quad Fold V */}
      {foldType === "Quad-Fold" && foldDirection === 2 && (
        <>
          <line
            x1="103.6"
            y1="37"
            x2="103.6"
            y2="160"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="73.6"
            y1="37"
            x2="73.6"
            y2="160"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="134.6"
            y1="37"
            x2="134.6"
            y2="160"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Five Fold V */}
      {foldType === "Five-Fold" && foldDirection === 2 && (
        <>
          <line x1="74.6" y1="45" x2="74.6" y2="160" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="99.6" y1="42" x2="99.6" y2="165" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="124.6" y1="42" x2="124.6" y2="165" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="149.6" y1="45" x2="149.6" y2="160" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Six Fold V */}
      {foldType === "Six-Fold" && foldDirection === 2 && (
        <>
          <line x1="70.4333" y1="50" x2="70.4333" y2="155" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="91.26" y1="42" x2="91.26" y2="165" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="112.09" y1="42" x2="112.09" y2="165" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="132.92" y1="42" x2="132.92" y2="165" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="153.75" y1="50" x2="153.75" y2="155" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Bi Fold H */}
      {foldType === "Bi-Fold" && foldDirection === 1 && (
        <line x1="42" y1="98.4" x2="167" y2="98.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
      )}

      {/* Tri Fold H */}
      {foldType === "Tri-Fold" && foldDirection === 1 && (
        <>
          <line x1="42" y1="73.4" x2="164" y2="73.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="42" y1="123.4" x2="164" y2="123.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Quad Fold H */}
      {foldType === "Quad-Fold" && foldDirection === 1 && (
        <>
          <line x1="47" y1="61.4" x2="165" y2="61.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="43" y1="98.4" x2="167" y2="98.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="45" y1="134.4" x2="165" y2="134.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Five Fold H */}
      {foldType === "Five-Fold" && foldDirection === 1 && (
        <>
          <line x1="48" y1="60.4" x2="162" y2="60.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="43" y1="85.4" x2="173" y2="85.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="43" y1="110.4" x2="173" y2="110.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="48" y1="135.4" x2="162" y2="135.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Six Fold H */}
      {foldType === "Six-Fold" && foldDirection === 1 && (
        <>
          <line x1="52" y1="56.23" x2="160" y2="56.23" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="43" y1="77.06" x2="173" y2="77.06" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="43" y1="97.89" x2="173" y2="97.89" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="43" y1="118.72" x2="173" y2="118.72" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="52" y1="139.55" x2="160" y2="139.55" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}
    </svg>
  );
};

export default Octagon;

